import { call, put, takeEvery, select } from 'redux-saga/effects';
import {
  submitQuizStart,
  submitQuizSuccess,
  submitQuizFailure
} from '../slices/quizSlice';
import { addNotification } from '../slices/uiSlice';

// Single API call to submit entire quiz
const submitQuizAPI = async (answers) => {
  const response = await fetch('https://54f0k4rqeb.execute-api.ap-south-1.amazonaws.com/prod/quiz', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ 
      answers,
      timestamp: new Date().toISOString()
    }),
  });
  
  if (!response.ok) {
    throw new Error('Failed to submit quiz');
  }
  
  return response.json();
};

function* handleSubmitQuiz(action) {
  try {
    const answers = yield select(state => state.quiz.answers);
    
    // Validate all required answers are present
    const requiredFields = ['fullName', 'email', 'age']; // Add all required fields
    const missingFields = requiredFields.filter(field => !answers[field]);
    
    if (missingFields.length > 0) {
      throw new Error(`Missing required fields: ${missingFields.join(', ')}`);
    }
    
    const response = yield call(submitQuizAPI, answers);
    
    yield put(submitQuizSuccess({
      reportUrl: response.report_url
    }));
    
    yield put(addNotification({
      type: 'success',
      message: 'Quiz submitted successfully! Generating your personalized report...',
      duration: 5000
    }));
    
    
  } catch (error) {
    console.log("error");
    yield put(submitQuizFailure(error.message));
    yield put(addNotification({
      type: 'error',
      message: `Submission failed: ${error.message}`,
      duration: 8000
    }));
  }
}

export function* watchSubmitQuiz() {
  yield takeEvery(submitQuizStart.type, handleSubmitQuiz);
}